/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _calendar_grid = __webpack_require__(1);
	
	var _calendar_grid2 = _interopRequireDefault(_calendar_grid);
	
	var _range_slider = __webpack_require__(3);
	
	var _range_slider2 = _interopRequireDefault(_range_slider);
	
	var _snap_slider = __webpack_require__(4);
	
	var _snap_slider2 = _interopRequireDefault(_snap_slider);
	
	var _simple_slider = __webpack_require__(5);
	
	var _simple_slider2 = _interopRequireDefault(_simple_slider);
	
	var _overlap = __webpack_require__(6);
	
	var _overlap2 = _interopRequireDefault(_overlap);
	
	var _stacked = __webpack_require__(7);
	
	var _stacked2 = _interopRequireDefault(_stacked);
	
	var _comparative = __webpack_require__(8);
	
	var _comparative2 = _interopRequireDefault(_comparative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(9);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _base = __webpack_require__(2);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// inspired by https://gist.github.com/mbostock/4b66c0d9be9a0d56484e
	
	var CalendarGridChart = function (_Chart) {
	  _inherits(CalendarGridChart, _Chart);
	
	  function CalendarGridChart() {
	    _classCallCheck(this, CalendarGridChart);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CalendarGridChart).apply(this, arguments));
	  }
	
	  _createClass(CalendarGridChart, [{
	    key: 'defineAxes',
	    value: function defineAxes() {
	      var grid_chart = this;
	
	      // y scale is dependent on number of months.
	      grid_chart.y_axis = d3.svg.axis().orient("left").outerTickSize(0);
	      grid_chart.y_scale = d3.scale.ordinal();
	      grid_chart.svg.append("g").attr("class", "d3-chart-range d3-chart-axis");
	
	      grid_chart.x_scale = d3.scale.ordinal().domain(d3.range(31).map(function (n) {
	        return n + 1;
	      })).rangeRoundBands([0, grid_chart.width], grid_chart.grid_padding, 0);
	
	      grid_chart.x_axis = d3.svg.axis().scale(grid_chart.x_scale).orient("top").outerTickSize(0);
	
	      // append x axis
	      grid_chart.svg.append("g").attr("class", "d3-chart-domain d3-chart-axis");
	    }
	  }, {
	    key: 'afterAxes',
	    value: function afterAxes() {
	      var grid_chart = this;
	      grid_chart.grid_unit_size = grid_chart.width / 31 - grid_chart.grid_padding * grid_chart.width / 30;
	
	      if (grid_chart.display_date_format) grid_chart.displayDate = d3.time.format(grid_chart.display_date_format);
	
	      if (!grid_chart.toDate && grid_chart.parse_date_format) {
	        grid_chart.parseDate = d3.time.format(grid_chart.parse_date_format);
	        grid_chart.toDate = function (datum) {
	          grid_chart.parseDate(datum[grid_chart.date_attr]);
	        };
	      } else if (!grid_chart.toDate) {
	        grid_chart.toDate = function (datum) {
	          return datum[grid_chart.date_attr];
	        };
	      }
	
	      grid_chart.monthFormat = d3.time.format(grid_chart.display_date_format);
	      grid_chart.toMonthString = function (datum) {
	        return grid_chart.monthFormat(grid_chart.toDate(datum));
	      };
	    }
	  }, {
	    key: 'serializeData',
	    value: function serializeData(data) {
	      var grid_chart = this;
	      data.css_class = data.css_class || grid_chart.toClass ? grid_chart.toClass(data) : "";
	
	      grid_chart.rangeValue = grid_chart.range_attr ? function (d) {
	        return d[grid_chart.range_attr];
	      } : grid_chart.rangeValue;
	
	      data.months = [];
	      if (data.min_range !== undefined && data.max_range !== undefined) {
	        data.range = {
	          min: data.min_range,
	          max: data.max_range
	        };
	        data.values.forEach(function (value) {
	          var date = grid_chart.toDate(value),
	              date_s = grid_chart.monthFormat(date);
	          if (data.months.indexOf(date_s) < 0) data.months.push(date_s);
	        });
	      } else {
	        var min_range = Infinity,
	            max_range = -Infinity;
	        data.values.forEach(function (value) {
	          var date = grid_chart.toDate(value),
	              date_s = grid_chart.monthFormat(date),
	              range_value = grid_chart.rangeValue(value);
	          min_range = Math.min(min_range, range_value);
	          max_range = Math.max(max_range, range_value);
	          if (data.months.indexOf(date_s) < 0) data.months.push(date_s);
	        });
	        if (grid_chart.min_range_zero) min_range = Math.min(min_range, 0);
	        data.range = {
	          min: min_range,
	          max: max_range
	        };
	      }
	      data.range.diff = data.range.max - data.range.min;
	
	      data.months = data.months.sort(function (date_s1, date_s2) {
	        var date1 = grid_chart.monthFormat.parse(date_s1),
	            date2 = grid_chart.monthFormat.parse(date_s2);
	        return date1.getTime() - date2.getTime();
	      });
	      return data;
	    }
	  }, {
	    key: 'drawLegend',
	    value: function drawLegend(data) {
	      var grid_chart = this;
	      var colors = [grid_chart.color_max, grid_chart.color_min];
	      grid_chart.gridSize = Math.floor(grid_chart.outer_width / 31);
	      grid_chart.legendElementWidth = grid_chart.gridSize * 3.5;
	
	      var colorlegend = grid_chart.svg.append("g").attr("class", "color-legend");
	      var legend = grid_chart.svg.append("g").attr("class", "legend").selectAll().data([data.range.min, data.range.max], function (d) {
	        return d;
	      });
	
	      legend.enter().append("text").attr("class", "legend-description");
	
	      var gradient = colorlegend.append("defs").append("linearGradient").attr("id", "gradient").attr("x1", "0%").attr("y1", "0%").attr("spreadMethod", "pad");
	
	      gradient.append("stop").attr("offset", "0%").attr("stop-color", colors[1]).attr("stop-opacity", 1);
	
	      gradient.append("stop").attr("offset", "100%").attr("stop-color", colors[0]).attr("stop-opacity", 1);
	
	      colorlegend.append("rect").attr("x", 0).attr("y", grid_chart.gridSize * data.months.length - 40).attr("width", 120).attr("height", 30).style("fill", "url(#gradient)");
	
	      legend.text(function (d) {
	        return Math.round(d);
	      }).attr("x", function (d, i) {
	        return grid_chart.legendElementWidth * i;
	      }).attr("y", grid_chart.gridSize * data.months.length + 5);
	
	      legend.exit().remove();
	    }
	  }, {
	    key: 'drawData',
	    value: function drawData(data) {
	      var grid_chart = this;
	      data = grid_chart.serializeData(data);
	      if (grid_chart.legend) grid_chart.drawLegend(data);
	
	      // calibrate axes
	      var y_axis_height = grid_chart.grid_unit_size * (1 + grid_chart.grid_padding) * data.months.length;
	      grid_chart.y_scale.rangeRoundBands([0, y_axis_height], grid_chart.grid_padding, 0);
	      grid_chart.y_scale.domain(data.months);
	      grid_chart.y_axis.scale(grid_chart.y_scale);
	
	      grid_chart.svg.select(".d3-chart-range").call(grid_chart.y_axis);
	
	      grid_chart.svg.select(".d3-chart-domain").call(grid_chart.x_axis);
	
	      var grid_units = grid_chart.svg.selectAll(".d3-chart-grid-unit").data(data.values);
	      grid_chart.applyData(data, grid_units.enter().append("rect"));
	      grid_chart.applyData(data, grid_units.transition());
	      grid_units.exit().remove();
	    }
	
	    // helper method for drawData.
	
	  }, {
	    key: 'applyData',
	    value: function applyData(data, elements) {
	      var grid_chart = this,
	          series_class = "d3-chart-grid-unit " + data.css_class;
	      elements.attr("class", function (d) {
	        return series_class;
	      }).attr("y", function (d) {
	        var bottom = grid_chart.y_scale(grid_chart.toMonthString(d)),
	            middle = grid_chart.y_scale.rangeBand() / 2 - grid_chart.grid_unit_size / 2;
	        return bottom + middle;
	      }).attr("height", grid_chart.grid_unit_size).attr("x", function (d) {
	        return grid_chart.x_scale(grid_chart.toDate(d).getDate());
	      }).attr("width", function (d) {
	        return grid_chart.grid_unit_size;
	      }).attr('fill', grid_chart.color_max).attr("opacity", function (d) {
	
	        return grid_chart.applyOpacity(grid_chart.rangeValue(d), data.range);
	      });
	    }
	  }, {
	    key: 'applyOpacity',
	    value: function applyOpacity(value, range) {
	      return Math.max(0, Math.min(1, 1 - (range.max - (value - range.min)) / range.diff));
	    }
	  }, {
	    key: 'chart_options',
	    get: function get() {
	      var chart = this;
	      return Object.assign(Object.assign({}, _base2.default.DEFAULTS), {
	        outer_width: 800,
	        outer_height: 360,
	        margin: {
	          top: 30,
	          left: 150,
	          bottom: 30,
	          right: 0
	        },
	        grid_padding: 0.05,
	        display_date_format: '%B %Y',
	        date_attr: 'date',
	        range_attr: 'value',
	        min_range_zero: false,
	        color_max: '#000',
	        color_min: '#fff',
	        legend: true,
	        chart_class: 'd3-calendar-grid'
	      });
	    }
	  }]);
	
	  return CalendarGridChart;
	}(_base2.default);
	
	exports.default = CalendarGridChart;

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULTS = {
	  outer_width: 500,
	  outer_height: 300,
	  margin: { top: 0, left: 70, bottom: 50, right: 20 },
	  domain_ticks: 10,
	  range_ticks: 8,
	  container: "container",
	  time_series: false,
	  range_label: undefined,
	  domain_attr: undefined,
	  range_attr: undefined,
	  titleize: function titleize(series, datum) {
	    var s = datum ? datum.name : series.title;
	    if (!s) return '';
	    var words = s.split(' '),
	        array = [];
	    for (var i = 0; i < words.length; ++i) {
	      array.push(words[i].charAt(0).toUpperCase() + words[i].toLowerCase().slice(1));
	    }
	    return array.join(' ');
	  },
	  toClass: function toClass(series) {
	    return series.css_class ? series.css_class.toLowerCase().replace(/\s+/g, '-') : "";
	  }
	};
	
	var Chart = function () {
	  function Chart(options) {
	    _classCallCheck(this, Chart);
	
	    var chart = this;
	    Object.assign(chart, chart.chart_options, options);
	
	    chart.height = chart.outer_height - chart.margin.top - chart.margin.bottom;
	    chart.width = chart.outer_width - chart.margin.left - chart.margin.right;
	
	    chart.svg = d3.select(chart.container).append("svg").attr("width", chart.outer_width).attr("height", chart.outer_height).attr('class', chart.chart_class || '').append("g").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")").attr('class', 'd3-object-container');
	
	    chart.defineAxes();
	    if (chart.afterAxes) chart.afterAxes();
	  }
	
	  _createClass(Chart, [{
	    key: 'drawOne',
	    value: function drawOne(selector, append, fn, scope) {
	      var chart = this,
	          selection = void 0;
	      scope = scope || chart.svg;
	      selection = scope.selectAll(selector).data([0]);
	      selection.exit().remove();
	      [selection.enter().append(append), selection].forEach(function (element) {
	        fn(element);
	      });
	      return selection;
	    }
	  }]);
	
	  return Chart;
	}();
	
	Chart.DEFAULTS = DEFAULTS;
	
	exports.default = Chart;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _base = __webpack_require__(2);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RangeSlider = function (_Chart) {
	  _inherits(RangeSlider, _Chart);
	
	  function RangeSlider() {
	    _classCallCheck(this, RangeSlider);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(RangeSlider).apply(this, arguments));
	  }
	
	  _createClass(RangeSlider, [{
	    key: 'defineAxes',
	    value: function defineAxes() {
	      var range_slider = this;
	
	      if (range_slider.date_range) {
	        range_slider.x_scale = d3.time.scale();
	        range_slider.x_scale.range([0, range_slider.width]).clamp(true);
	      } else {
	        range_slider.x_scale = d3.scale.linear();
	        range_slider.x_scale.range([0, range_slider.width]).clamp(true);
	      }
	
	      range_slider.x_axis = range_slider.x_axis || d3.svg.axis();
	      range_slider.x_axis.scale(range_slider.x_scale).orient("bottom").tickSize(1).ticks(range_slider.tick_amount).outerTickSize(1).tickPadding(12);
	
	      range_slider.drawOne('.d3-chart-domain.d3-slider-axis', 'g', function (axis) {
	        axis.attr("class", "d3-chart-domain d3-slider-axis");
	        axis.attr("transform", "translate(0," + range_slider.height / 2 + ")");
	      });
	    }
	  }, {
	    key: 'afterAxes',
	    value: function afterAxes() {
	      var range_slider = this;
	
	      range_slider.slider = range_slider.drawOne('.d3-chart-slider', 'g', function (slider) {
	        slider.attr("class", "d3-chart-slider");
	      });
	
	      range_slider.min_handle = range_slider.drawOne('.d3-chart-slider .d3-chart-min-handle', 'circle', function (min_handle) {
	        min_handle.attr("class", "d3-chart-min-handle").attr("transform", "translate(0," + range_slider.height / 2 + ")").attr("r", range_slider.handle_r);
	      }, range_slider.slider);
	
	      range_slider.max_handle = range_slider.drawOne('.d3-chart-slider .d3-chart-max-handle', 'circle', function (max_handle) {
	        max_handle.attr("class", "d3-chart-max-handle").attr("transform", "translate(0," + range_slider.height / 2 + ")").attr("r", range_slider.handle_r);
	      }, range_slider.slider);
	
	      range_slider.brush = d3.svg.brush();
	      range_slider.brush.x(range_slider.x_scale);
	
	      range_slider.slider.call(range_slider.brush);
	
	      range_slider.slider.call(range_slider.brush).selectAll(".extent,.resize").remove();
	    }
	  }, {
	    key: 'drawData',
	    value: function drawData(data) {
	      var range_slider = this;
	      range_slider.x_scale.domain([data.abs_min, data.abs_max]);
	
	      range_slider.svg.select(".d3-chart-domain").call(range_slider.x_axis);
	
	      range_slider.min_handle.attr('cx', range_slider.x_scale(data.current_min));
	      range_slider.max_handle.attr('cx', range_slider.x_scale(data.current_max));
	
	      range_slider.brush.extent([data.current_min, data.current_min]).on("brush", function () {
	        RangeSlider.handleBrush(range_slider, eval('this'));
	      });
	
	      range_slider.slider.call(range_slider.brush.event).transition().duration(750).call(range_slider.brush.extent([data.current_min, data.current_min])).call(range_slider.brush.event);
	      range_slider.data = data;
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta(type, changed_datum, other_datum) {
	      var range_slider = this;
	
	      if (type === 'max') {
	        if (range_slider.date_range) {
	          if (Math.abs(changed_datum.getTime() - other_datum.getTime()) > range_slider.delta.max) {
	            if (changed_datum > other_datum) {
	              return new Date(changed_datum.getTime() - range_slider.delta.max);
	            } else {
	              return new Date(changed_datum.getTime() + range_slider.delta.max);
	            }
	          }
	        } else {
	          if (Math.abs(changed_datum - other_datum) > range_slider.delta.max) {
	            if (changed_datum > other_datum) {
	              return changed_datum - range_slider.delta.max;
	            } else {
	              return changed_datum + range_slider.delta.max;
	            }
	          }
	        }
	        return false;
	      } else if (type === 'min') {
	        if (range_slider.date_range) {
	          if (Math.abs(changed_datum.getTime() - other_datum.getTime()) <= range_slider.delta.min) {
	            if (changed_datum < other_datum) {
	              return new Date(changed_datum.getTime() + range_slider.delta.min);
	            } else {
	              return new Date(changed_datum.getTime() - range_slider.delta.min);
	            }
	          }
	        } else {
	          if (Math.abs(changed_datum - other_datum) <= range_slider.delta.min) {
	            if (changed_datum < other_datum) {
	              return changed_datum + range_slider.delta.min;
	            } else {
	              return changed_datum - range_slider.delta.min;
	            }
	          }
	        }
	        return false;
	      }
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw(opts) {
	      var chart = this;
	      Object.assign(chart, opts);
	      chart.height = chart.outer_height - chart.margin.top - chart.margin.bottom;
	      chart.width = chart.outer_width - chart.margin.left - chart.margin.right;
	
	      d3.select(chart.container + ' svg').attr("width", chart.outer_width).attr("height", chart.outer_height).select(".d3-object-container").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");
	      chart.defineAxes();
	      if (chart.afterAxes) chart.afterAxes();
	      chart.drawData(chart.data);
	    }
	  }, {
	    key: 'chart_options',
	    get: function get() {
	      return Object.assign(Object.assign({}, _base2.default.DEFAULTS), {
	        outer_width: 600,
	        outer_height: 100,
	        margin: {
	          top: 20,
	          left: 30,
	          bottom: 20,
	          right: 30
	        },
	        tick_amount: 6,
	        chart_class: 'd3-range-slider',
	        handle_r: 9
	      });
	    }
	  }], [{
	    key: 'handleBrush',
	    value: function handleBrush(range_slider, elem) {
	      var datum = range_slider.brush.extent()[0],
	          current_min = parseInt(range_slider.min_handle.attr('cx')),
	          current_max = parseInt(range_slider.max_handle.attr('cx'));
	
	      if (!current_min && !current_max) return false;
	      if (d3.event.sourceEvent) {
	        // not a programmatic event
	        datum = range_slider.x_scale.invert(d3.mouse(elem)[0]);
	        range_slider.brush.extent([datum, datum]);
	      }
	
	      var value = range_slider.x_scale(datum);
	
	      if (value < current_max && value > current_min) {
	        // move min / max handle towards the other handle
	        if (Math.abs(value - current_min) < Math.abs(value - current_max)) {
	          // move min towards max
	          range_slider.min_handle.attr('cx', value);
	          current_min = value;
	          if (d3.event.sourceEvent && range_slider.delta.min) {
	            var new_current_min = range_slider.getDelta('min', datum, range_slider.x_scale.invert(current_max));
	            if (new_current_min) range_slider.max_handle.attr('cx', range_slider.x_scale(new_current_min));
	          }
	        } else {
	          // move max towards min
	          range_slider.max_handle.attr('cx', value);
	          current_max = value;
	          if (d3.event.sourceEvent && range_slider.delta.min) {
	            var new_current_min = range_slider.getDelta('min', datum, range_slider.x_scale.invert(current_min));
	            if (new_current_min) range_slider.min_handle.attr('cx', range_slider.x_scale(new_current_min));
	          }
	        }
	      } else if (value >= current_max) {
	        // move max handle
	        range_slider.max_handle.attr('cx', value);
	        current_max = value;
	        if (d3.event.sourceEvent && range_slider.delta.max) {
	          var new_current_min = range_slider.getDelta('max', datum, range_slider.x_scale.invert(current_min));
	          if (new_current_min) range_slider.min_handle.attr('cx', range_slider.x_scale(new_current_min));
	        }
	      } else if (value <= current_min) {
	        range_slider.min_handle.attr('cx', value);
	        current_min = value;
	        if (d3.event.sourceEvent && range_slider.delta.max) {
	          var new_current_max = range_slider.getDelta('max', datum, range_slider.x_scale.invert(current_max));
	          if (new_current_max) range_slider.max_handle.attr('cx', range_slider.x_scale(new_current_max));
	        }
	      }
	
	      if (d3.event.sourceEvent && range_slider.onRangeUpdated) {
	        range_slider.onRangeUpdated(range_slider.x_scale.invert(current_min), range_slider.x_scale.invert(current_max));
	      }
	    }
	  }]);
	
	  return RangeSlider;
	}(_base2.default);
	
	exports.default = RangeSlider;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _base = __webpack_require__(2);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SnapSlider = function (_Chart) {
	  _inherits(SnapSlider, _Chart);
	
	  function SnapSlider() {
	    _classCallCheck(this, SnapSlider);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(SnapSlider).apply(this, arguments));
	  }
	
	  _createClass(SnapSlider, [{
	    key: 'defineAxes',
	    value: function defineAxes() {
	      var snap_slider = this;
	
	      snap_slider.ensureTickHelpers();
	
	      if (snap_slider.date_range) {
	        snap_slider.x_scale = d3.time.scale().range([0, snap_slider.width]).clamp(true);
	      } else {
	        snap_slider.x_scale = d3.scale.linear().range([0, snap_slider.width]).clamp(true);
	      }
	
	      snap_slider.x_axis = d3.svg.axis().scale(snap_slider.x_scale).orient("bottom").tickSize(1).tickValues(snap_slider.tick_values).tickFormat(function (d) {
	        return snap_slider.tickLabel(d);
	      }).outerTickSize(1).tickPadding(12);
	
	      snap_slider.drawOne('.d3-chart-domain.d3-slider-axis', 'g', function (g) {
	        g.attr("class", "d3-chart-domain d3-slider-axis").attr("transform", "translate(0," + snap_slider.height / 2 + ")");
	      });
	    }
	  }, {
	    key: 'ensureTickHelpers',
	    value: function ensureTickHelpers() {
	      var snap_slider = this;
	      if (snap_slider.tick_values === undefined) {
	        snap_slider.tick_values = Object.keys(snap_slider.tick_labels).map(function (val) {
	          return parseInt(val);
	        });
	      }
	      if (snap_slider.tickLabel === undefined && snap_slider.tick_labels === undefined) {
	        snap_slider.tickLabel = function (tick_value) {
	          return tick_value;
	        };
	      } else if (snap_slider.tickLabel === undefined) {
	        snap_slider.tickLabel = function (tick_value) {
	          return snap_slider.tick_labels[tick_value];
	        };
	      }
	    }
	  }, {
	    key: 'afterAxes',
	    value: function afterAxes() {
	      var snap_slider = this;
	
	      snap_slider.slider = snap_slider.drawOne('.d3-chart-slider', 'g', function (g) {
	        g.attr("class", "d3-chart-slider");
	      });
	
	      snap_slider.handle = snap_slider.drawOne('.d3-chart-handle', 'circle', function (handle) {
	        handle.attr("class", "d3-chart-handle").attr("transform", "translate(0," + snap_slider.height / 2 + ")").attr("r", snap_slider.handle_r);
	      }, snap_slider.slider);
	
	      snap_slider.brush = d3.svg.brush().x(snap_slider.x_scale);
	
	      snap_slider.slider.call(snap_slider.brush);
	
	      snap_slider.slider.call(snap_slider.brush).selectAll(".extent,.resize").remove();
	
	      if (snap_slider.axis_click_handle) {
	        snap_slider.svg.select(".background").attr("transform", "translate(0," + (snap_slider.height / 2 - snap_slider.handle_r) + ")").attr("height", snap_slider.handle_r * 2);
	      }
	    }
	  }, {
	    key: 'drawData',
	    value: function drawData(data) {
	      var snap_slider = this;
	      snap_slider.x_scale.domain([data.abs_min, data.abs_max]);
	
	      snap_slider.svg.select(".d3-chart-domain").call(snap_slider.x_axis);
	
	      snap_slider.handle.attr('cx', snap_slider.x_scale(data.current_value));
	
	      snap_slider.brush.extent([data.current_value, data.current_value]).on("brush", function () {
	        SnapSlider.handleBrush(snap_slider, eval('this'));
	      });
	
	      snap_slider.slider.call(snap_slider.brush.event).transition().duration(750).call(snap_slider.brush.extent([data.current_value, data.current_value])).call(snap_slider.brush.event);
	
	      d3.select(snap_slider.container).selectAll('.tick').on('click', function (d) {
	        var click_position = snap_slider.x_scale(d);
	        snap_slider.handle.transition().attr('cx', click_position);
	        if (snap_slider.onSnap) {
	          snap_slider.onSnap(d);
	        }
	      });
	
	      snap_slider.current_value = data.current_value;
	      snap_slider.data = data;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value, opts) {
	      opts = Object.assign({
	        exec_callback: true
	      }, opts || {});
	
	      var snap_slider = this;
	      value = snap_slider.findNearestTickValue(value);
	      snap_slider.data.current_value = value;
	
	      snap_slider.current_value = value;
	      var value_position = snap_slider.x_scale(value);
	      snap_slider.handle.attr('cx', value_position);
	
	      if (snap_slider.onSnap && opts.exec_callback) {
	        snap_slider.onSnap(value);
	      }
	    }
	  }, {
	    key: 'findNearestTickValue',
	    value: function findNearestTickValue(value) {
	      var snap_slider = this,
	          snap_value = undefined;
	      // SnapSlider#ticks must be sorted ASC.
	
	      for (var i = 0; i < snap_slider.tick_values.length; i++) {
	        var this_value = snap_slider.tick_values[i],
	            next_value = snap_slider.tick_values[i + 1];
	        if (next_value === undefined) {
	          return this_value;
	        } else if (value < next_value) {
	          var snap_position = void 0;
	          if (Math.abs(value - this_value) < Math.abs(value - next_value)) {
	            return this_value;
	          } else {
	            return next_value;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw(opts) {
	      var chart = this;
	      Object.assign(chart, opts);
	      chart.height = chart.outer_height - chart.margin.top - chart.margin.bottom;
	      chart.width = chart.outer_width - chart.margin.left - chart.margin.right;
	
	      d3.select(chart.container + ' svg').attr("width", chart.outer_width).attr("height", chart.outer_height).select(".d3-object-container").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");
	      chart.defineAxes();
	      if (chart.afterAxes) chart.afterAxes();
	      chart.drawData(chart.data);
	    }
	  }, {
	    key: 'chart_options',
	    get: function get() {
	      return Object.assign(Object.assign({}, _base2.default.DEFAULTS), {
	        outer_width: 600,
	        outer_height: 100,
	        margin: {
	          top: 20,
	          left: 30,
	          bottom: 20,
	          right: 30
	        },
	        tick_amount: 6,
	        chart_class: 'd3-snap-slider',
	        snap_debounce: 150,
	        handle_r: 9
	      });
	    }
	  }], [{
	    key: 'handleBrush',
	    value: function handleBrush(snap_slider, elem) {
	      var brush_value = snap_slider.brush.extent()[0],
	          handle_position = parseInt(snap_slider.handle.attr('cx'));
	
	      var source_event = d3.event.sourceEvent;
	      if (handle_position === null || !source_event) return false;
	
	      if (source_event) {
	        // UI triggered event
	        brush_value = snap_slider.x_scale.invert(d3.mouse(elem)[0]);
	        snap_slider.brush.extent([brush_value, brush_value]);
	      }
	
	      var brush_position = snap_slider.x_scale(brush_value);
	
	      snap_slider.handle.attr('cx', brush_position);
	
	      // don't continually snap - debounce every 500ms.
	      if (snap_slider.$handle_brush) clearTimeout(snap_slider.$handle_brush);
	
	      snap_slider.$handle_brush = setTimeout(function () {
	        // set handle position to closes tick mark.
	        var snap_value = snap_slider.findNearestTickValue(brush_value),
	            snap_position = snap_slider.x_scale(snap_value);
	        snap_slider.handle.transition().attr('cx', snap_position);
	        snap_slider.current_value = snap_value;
	
	        // execute callback after handle has been snapped.
	        if (source_event && snap_slider.onSnap) {
	          snap_slider.onSnap(snap_value);
	        }
	      }, snap_slider.snap_debounce);
	    }
	  }]);
	
	  return SnapSlider;
	}(_base2.default);
	
	exports.default = SnapSlider;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _base = __webpack_require__(2);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleSlider = function (_Chart) {
	  _inherits(SimpleSlider, _Chart);
	
	  function SimpleSlider() {
	    _classCallCheck(this, SimpleSlider);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(SimpleSlider).apply(this, arguments));
	  }
	
	  _createClass(SimpleSlider, [{
	    key: 'defineAxes',
	    value: function defineAxes() {
	      var simple_slider = this;
	
	      simple_slider.ensureTickHelpers();
	
	      if (simple_slider.date_range) {
	        simple_slider.x_scale = d3.time.scale().range([0, simple_slider.width]).clamp(true);
	      } else {
	        simple_slider.x_scale = d3.scale.linear().range([0, simple_slider.width]).clamp(true);
	      }
	
	      simple_slider.x_axis = d3.svg.axis().scale(simple_slider.x_scale).orient("bottom").tickSize(1).tickValues(simple_slider.tick_values).tickFormat(function (d) {
	        return simple_slider.tickLabel(d);
	      }).outerTickSize(1).tickPadding(12);
	
	      simple_slider.drawOne('.d3-chart-domain.d3-slider-axis', 'g', function (axis) {
	        axis.attr("class", "d3-chart-domain d3-slider-axis").attr("transform", "translate(0," + simple_slider.height / 2 + ")");
	      });
	    }
	  }, {
	    key: 'ensureTickHelpers',
	    value: function ensureTickHelpers() {
	      var simple_slider = this;
	      if (simple_slider.tick_values === undefined) {
	        simple_slider.tick_values = Object.keys(simple_slider.tick_labels).map(function (val) {
	          return parseInt(val);
	        });
	      }
	      if (simple_slider.tickLabel === undefined && simple_slider.tick_labels === undefined) {
	        simple_slider.tickLabel = function (tick_value) {
	          return tick_value;
	        };
	      } else if (simple_slider.tickLabel === undefined) {
	        simple_slider.tickLabel = function (tick_value) {
	          return simple_slider.tick_labels[tick_value];
	        };
	      }
	    }
	  }, {
	    key: 'afterAxes',
	    value: function afterAxes() {
	      var simple_slider = this;
	
	      simple_slider.slider = simple_slider.drawOne('.d3-chart-slider', 'g', function (slider) {
	        slider.attr("class", "d3-chart-slider");
	      });
	
	      simple_slider.handle = simple_slider.drawOne('.d3-chart-handle', 'circle', function (handle) {
	        handle.attr("class", "d3-chart-handle").attr("transform", "translate(0," + simple_slider.height / 2 + ")").attr("r", simple_slider.handle_r);
	      }, simple_slider.slider);
	
	      simple_slider.brush = d3.svg.brush().x(simple_slider.x_scale);
	
	      simple_slider.slider.call(simple_slider.brush);
	
	      simple_slider.slider.call(simple_slider.brush).selectAll(".extent,.resize").remove();
	
	      if (simple_slider.axis_click_handle) {
	        simple_slider.svg.select(".background").attr("transform", "translate(0," + (simple_slider.height / 2 - simple_slider.handle_r) + ")").attr("height", simple_slider.handle_r * 2);
	      }
	    }
	  }, {
	    key: 'drawData',
	    value: function drawData(data) {
	      var simple_slider = this;
	      simple_slider.x_scale.domain([data.abs_min, data.abs_max]);
	
	      simple_slider.svg.select(".d3-chart-domain").call(simple_slider.x_axis);
	
	      simple_slider.handle.attr('cx', simple_slider.x_scale(data.current_value));
	
	      simple_slider.brush.extent([data.current_value, data.current_value]).on("brush", function () {
	        // weird event context hack.
	        SimpleSlider.handleBrush(simple_slider, eval('this'));
	      });
	
	      simple_slider.slider.call(simple_slider.brush.event).transition().duration(750).call(simple_slider.brush.extent([data.current_value, data.current_value])).call(simple_slider.brush.event);
	
	      d3.select(simple_slider.container).selectAll('.tick').on('click', function (d) {
	        var click_position = simple_slider.x_scale(d);
	        simple_slider.handle.transition().attr('cx', click_position);
	        if (simple_slider.onChange) {
	          simple_slider.onChange(d);
	        }
	      });
	
	      simple_slider.data = data;
	      simple_slider.current_value = data.current_value;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value, opts) {
	      opts = Object.assign({
	        exec_callback: true
	      }, opts || {});
	      var simple_slider = this;
	      simple_slider.data.current_value = value;
	
	      simple_slider.current_value = value;
	      var value_position = simple_slider.x_scale(value);
	      simple_slider.handle.attr('cx', value_position);
	
	      if (simple_slider.onChange && opts.exec_callback) {
	        simple_slider.onChange(value);
	      }
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw(opts) {
	      var chart = this;
	      Object.assign(chart, opts);
	      chart.height = chart.outer_height - chart.margin.top - chart.margin.bottom;
	      chart.width = chart.outer_width - chart.margin.left - chart.margin.right;
	
	      d3.select(chart.container + ' svg').attr("width", chart.outer_width).attr("height", chart.outer_height).select(".d3-object-container").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");
	
	      chart.defineAxes();
	      if (chart.afterAxes) chart.afterAxes();
	      chart.drawData(chart.data);
	    }
	  }, {
	    key: 'chart_options',
	    get: function get() {
	      return Object.assign(Object.assign({}, _base2.default.DEFAULTS), {
	        outer_width: 600,
	        outer_height: 100,
	        margin: {
	          top: 20,
	          left: 30,
	          bottom: 20,
	          right: 30
	        },
	        tick_amount: 6,
	        callback_debounce: 200,
	        chart_class: 'd3-simple-slider',
	        handle_r: 9
	      });
	    }
	  }], [{
	    key: 'handleBrush',
	    value: function handleBrush(simple_slider, elem) {
	      var brush_value = simple_slider.brush.extent()[0],
	          handle_position = parseInt(simple_slider.handle.attr('cx'));
	
	      var source_event = d3.event.sourceEvent;
	      if (handle_position === null || !source_event) return false;
	
	      if (source_event) {
	        // UI triggered event
	        brush_value = simple_slider.x_scale.invert(d3.mouse(elem)[0]);
	        simple_slider.brush.extent([brush_value, brush_value]);
	      }
	
	      var brush_position = simple_slider.x_scale(brush_value);
	
	      simple_slider.handle.attr('cx', brush_position);
	
	      if (!simple_slider.onChange || !source_event) return false;
	
	      // don't continually snap - debounce according to callback_debounce.
	      if (simple_slider.$handle_brush) clearTimeout(simple_slider.$handle_brush);
	
	      simple_slider.$handle_brush = setTimeout(function () {
	        simple_slider.onChange(brush_value);
	      }, simple_slider.callback_debounce);
	    }
	  }]);
	
	  return SimpleSlider;
	}(_base2.default);
	
	exports.default = SimpleSlider;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _base = __webpack_require__(2);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverlapBar = function (_Chart) {
	  _inherits(OverlapBar, _Chart);
	
	  function OverlapBar() {
	    _classCallCheck(this, OverlapBar);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(OverlapBar).apply(this, arguments));
	  }
	
	  _createClass(OverlapBar, [{
	    key: 'defineAxes',
	    value: function defineAxes() {
	      var overlap_bar = this;
	      // y scale is dependent on number of months.
	      overlap_bar.y_axis = d3.svg.axis().orient("left").ticks(overlap_bar.y_ticks).outerTickSize(0).tickFormat(overlap_bar.yTickFormat);
	      overlap_bar.y_scale = d3.scale.linear();
	
	      overlap_bar.drawOne('.d3-chart-range.d3-chart-axis', 'g', function (range_axis) {
	        range_axis.attr("class", "d3-chart-range d3-chart-axis");
	      });
	
	      overlap_bar.x_scale = d3.scale.ordinal();
	
	      overlap_bar.x_axis = d3.svg.axis().orient('bottom').outerTickSize(0).tickFormat(overlap_bar.xTickFormat);
	
	      // append x axis
	      overlap_bar.drawOne('.d3-chart-domain.d3-chart-axis', 'g', function (domain_axis) {
	        domain_axis.attr("class", "d3-chart-domain d3-chart-axis").attr("transform", "translate(0," + overlap_bar.height + ")");
	      });
	
	      overlap_bar.fnColor = overlap_bar.fnColor || d3.scale.category20();
	    }
	  }, {
	    key: 'drawData',
	    value: function drawData(data) {
	      var overlap_bar = this;
	
	      overlap_bar.x_scale.domain(data.categories).rangeRoundBands([0, overlap_bar.width], 0.1, 0);;
	      overlap_bar.x_axis.scale(overlap_bar.x_scale);
	
	      var extent = overlap_bar.dataExtent(data);
	      overlap_bar.y_scale.domain(extent).range([overlap_bar.height, 0]);
	      overlap_bar.y_axis.scale(overlap_bar.y_scale);
	
	      overlap_bar.svg.select(".d3-chart-range").call(overlap_bar.y_axis);
	
	      overlap_bar.svg.select(".d3-chart-domain").call(overlap_bar.x_axis);
	
	      data.series.forEach(function (data_series) {
	        var series_class = overlap_bar.fnSeriesClass(data_series),
	            bars = overlap_bar.svg.selectAll('.' + series_class).data(data_series.values);
	        overlap_bar.applyData(data_series, bars, data.categories);
	        overlap_bar.applyData(data_series, bars.enter().append("rect"), data.categories);
	        bars.exit().remove();
	      });
	      overlap_bar.data = data;
	      return overlap_bar;
	    }
	  }, {
	    key: 'dataExtent',
	    value: function dataExtent(data) {
	      var min = 0,
	          max = 0;
	      for (var i = 0; i < data.series.length; i++) {
	        var series = data.series[i];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = series.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var value = _step.value;
	
	            min = Math.min(min, value);
	            max = Math.max(max, value);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      return [min, max];
	    }
	  }, {
	    key: 'applyData',
	    value: function applyData(data_series, bars, categories) {
	      var overlap_bar = this,
	          series_class = "d3-overlap-bar " + overlap_bar.fnSeriesClass(data_series);
	
	      bars.attr("class", function (d, i) {
	        var category_class = overlap_bar.fnCategoryClass(categories[i]);
	        return [series_class, category_class].join(' ');
	      }).attr("y", function (d) {
	        return overlap_bar.y_scale(d);
	      }).attr("height", function (d) {
	        return overlap_bar.height - overlap_bar.y_scale(d);
	      }).attr("x", function (d, i) {
	        return overlap_bar.x_scale(categories[i]);
	      }).attr("width", function (d) {
	        return overlap_bar.x_scale.rangeBand();
	      });
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw(opts) {
	      var chart = this;
	      Object.assign(chart, opts);
	      chart.height = chart.outer_height - chart.margin.top - chart.margin.bottom;
	      chart.width = chart.outer_width - chart.margin.left - chart.margin.right;
	      d3.select(chart.container + ' svg').attr("width", chart.outer_width).attr("height", chart.outer_height).select(".d3-object-container").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");
	      chart.defineAxes();
	      if (chart.afterAxes) chart.afterAxes();
	      chart.drawData(chart.data);
	    }
	  }, {
	    key: 'chart_options',
	    get: function get() {
	      return Object.assign(Object.assign({}, _base2.default.DEFAULTS), {
	        outer_width: 600,
	        outer_height: 400,
	        margin: {
	          top: 20,
	          left: 30,
	          bottom: 20,
	          right: 30
	        },
	        y_ticks: 7,
	        chart_class: 'd3-chart-slider',
	        fnSeriesClass: function fnSeriesClass(series) {
	          return series.name.replace(/\s+/g, '-').toLowerCase();
	        },
	        fnCategoryClass: function fnCategoryClass(category) {
	          return category.replace(/\s+/g, '-').toLowerCase();
	        },
	        xTickFormat: function xTickFormat(d, i) {
	          return d;
	        },
	        yTickFormat: function yTickFormat(d, i) {
	          return d;
	        }
	      });
	    }
	  }]);
	
	  return OverlapBar;
	}(_base2.default);
	
	exports.default = OverlapBar;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _base = __webpack_require__(2);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StackedBar = function (_Chart) {
	    _inherits(StackedBar, _Chart);
	
	    function StackedBar() {
	        _classCallCheck(this, StackedBar);
	
	        return _possibleConstructorReturn(this, Object.getPrototypeOf(StackedBar).apply(this, arguments));
	    }
	
	    _createClass(StackedBar, [{
	        key: 'defineAxes',
	        value: function defineAxes() {
	            var stacked_bar = this;
	            stacked_bar.y_axis = d3.svg.axis().orient('left').ticks(stacked_bar.y_ticks).outerTickSize(0).tickFormat(stacked_bar.yTickFormat);
	            stacked_bar.y_scale = d3.scale.linear();
	
	            stacked_bar.drawOne('.d3-chart-range.d3-chart-axis', 'g', function (range_axis) {
	                range_axis.attr('class', 'd3-chart-range d3-chart-axis');
	            });
	
	            stacked_bar.x_scale = d3.scale.ordinal();
	
	            stacked_bar.x_axis = d3.svg.axis().orient('bottom').outerTickSize(0).tickFormat(stacked_bar.xTickFormat);
	
	            stacked_bar.drawOne('.d3-chart-domain.d3-chart-axis', 'g', function (domain_axis) {
	                domain_axis.attr('class', 'd3-chart-domain d3-chart-axis').attr('transform', 'translate(0,' + stacked_bar.height + ')');
	            });
	
	            stacked_bar.fnColor = stacked_bar.fnColor || d3.scale.category20();
	
	            stacked_bar.tooltip = d3.select(stacked_bar.container).append('div').attr('class', 'stacked-bar-tooltip');
	        }
	    }, {
	        key: 'drawData',
	        value: function drawData(data) {
	            var stacked_bar = this;
	
	            stacked_bar.x_scale.domain(data.map(function (d) {
	                return d.name;
	            })).rangeRoundBands([0, stacked_bar.width], .1, 0);
	            stacked_bar.x_axis.scale(stacked_bar.x_scale);
	
	            stacked_bar.extent = stacked_bar.dataExtent(data);
	            stacked_bar.y_scale.domain(stacked_bar.extent).range([stacked_bar.height, 0]);
	            stacked_bar.y_axis.scale(stacked_bar.y_scale);
	
	            stacked_bar.svg.select('.d3-chart-range').call(stacked_bar.y_axis);
	
	            stacked_bar.svg.select('.d3-chart-domain').call(stacked_bar.x_axis);
	
	            data.forEach(function (series, i) {
	                var y0 = 0;
	
	                series.values.map(function (item) {
	                    item.y0 = y0;
	                    item.y1 = y0 += item.value;
	                });
	            });
	            var bars = stacked_bar.svg.selectAll('g.series').data(data).enter().append('g').attr('class', function (d) {
	                return stacked_bar.fnClassName(d.name) + ' series';
	            });
	
	            stacked_bar.svg.selectAll('g.series').attr('transform', function (d) {
	                return 'translate(' + stacked_bar.x_scale(d.name) + ',0)';
	            });
	
	            var bar_enter = bars.selectAll('rect').data(function (d) {
	                return d.values;
	            }).enter();
	
	            bar_enter.append('rect');
	            bar_enter.append('text');
	
	            var rects = stacked_bar.svg.selectAll('g.series').selectAll('rect');
	            var texts = stacked_bar.svg.selectAll('g.series').selectAll('text');
	
	            stacked_bar.applyData(rects);
	            if (stacked_bar.labels) {
	                stacked_bar.applyLabels(texts);
	                stacked_bar.wrap(stacked_bar.svg.selectAll('.series text'), stacked_bar.x_scale.rangeBand());
	            }
	            if (stacked_bar.hover_tooltips) stacked_bar.applyTooltip(bars);
	
	            stacked_bar.data = data;
	            return stacked_bar;
	        }
	    }, {
	        key: 'dataExtent',
	        value: function dataExtent(data) {
	            var max = 0;
	            for (var i = 0; i < data.length; i++) {
	                var sum = 0;
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = data[i].values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var item = _step.value;
	
	                        sum += item.value;
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                max = Math.max(max, sum);
	            }
	            return [0, max];
	        }
	    }, {
	        key: 'applyData',
	        value: function applyData(bars) {
	            var stacked_bar = this;
	            bars.attr('class', function (d) {
	                return stacked_bar.fnClassName(d.title);
	            }).attr('y', function (d) {
	                return stacked_bar.y_scale(d.y1);
	            }).attr('height', function (d) {
	                return stacked_bar.y_scale(d.y0) - stacked_bar.y_scale(d.y1);
	            }).style('fill', stacked_bar.rect_color).style('stroke', stacked_bar.divider_color).attr('width', stacked_bar.x_scale.rangeBand());
	        }
	    }, {
	        key: 'applyLabels',
	        value: function applyLabels(bars) {
	            var stacked_bar = this;
	            bars.text(function (d) {
	                return d.title;
	            }).attr('transform', function (d, i) {
	                d.x = stacked_bar.x_scale.rangeBand() / 2;
	                if (d.value * 100 / stacked_bar.extent[1] < 15) {
	                    d.y = stacked_bar.y_scale(d.y1) + (stacked_bar.y_scale(d.y0) - stacked_bar.y_scale(d.y1)) / 1.6;
	                } else {
	                    d.y = stacked_bar.y_scale(d.y1) + (stacked_bar.y_scale(d.y0) - stacked_bar.y_scale(d.y1)) / 1.9;
	                }
	                return 'translate(' + d.x + ',' + d.y + ')';
	            }).attr('text-anchor', 'middle').style('font-size', function (d) {
	                return d.value * 100 / stacked_bar.extent[1] < 7.5 ? '0px' : '12px';
	            }).style('fill', '#ffffff');
	        }
	    }, {
	        key: 'applyTooltip',
	        value: function applyTooltip(bars) {
	            var _this2 = this;
	
	            var stacked_bar = this;
	            bars.on('mousemove', function (d) {
	                stacked_bar.tooltip.style('left', d3.event.pageX + 15 + 'px');
	                stacked_bar.tooltip.style('top', d3.event.pageY - 25 + 'px');
	                stacked_bar.tooltip.style('display', 'inline-block');
	                var current = document.querySelectorAll(':hover') || document.querySelectorAll(':focus');
	                var item = current[current.length - 1].__data__;
	                stacked_bar.tooltip.html(_this2.makeTooltipHtml(item));
	            });
	            bars.on('mouseout', function () {
	                return stacked_bar.tooltip.style('display', 'none');
	            });
	        }
	    }, {
	        key: 'redraw',
	        value: function redraw(opts) {
	            var chart = this;
	            Object.assign(chart, opts);
	            chart.height = chart.outer_height - chart.margin.top - chart.margin.bottom;
	            chart.width = chart.outer_width - chart.margin.left - chart.margin.right;
	            d3.select(chart.container + ' svg').attr('width', chart.outer_width).attr('height', chart.outer_height).select('.d3-object-container').attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')');
	            chart.defineAxes();
	            if (chart.afterAxes) chart.afterAxes();
	            chart.drawData(chart.data);
	        }
	    }, {
	        key: 'wrap',
	        value: function wrap(textList, width) {
	            textList[0].forEach(function (t) {
	                var text = d3.select(t);
	                var textWidth = text.node().getBBox().width;
	                var innerText = text.text();
	                var words = text.text().split(/\s+/).reverse(),
	                    word = void 0,
	                    line = [],
	                    lineNumber = 0,
	                    lineHeight = 1.1,
	                    y = textWidth > width ? text.attr('y') - 6 : text.attr('y'),
	                    tspan = text.text(null).append('tspan').attr('x', 0).attr('y', y);
	                if (textWidth > width && words.length === 1) {
	                    words = innerText.match(new RegExp('.{1,' + words[0].length / 2 + '}', 'g')).reverse();
	                    words[words.length - 1] = words[words.length - 1].concat('-');
	                }
	                while (word = words.pop()) {
	                    line.push(word);
	                    tspan.text(line.join(' '));
	                    if (tspan.node().getComputedTextLength() > width) {
	                        line.pop();
	                        tspan.text(line.join(' '));
	                        line = [word];
	                        tspan = text.append('tspan').attr('x', 0).attr('y', y).attr('dy', ++lineNumber * lineHeight + 'em').text(word);
	                    }
	                }
	            });
	        }
	    }, {
	        key: 'chart_options',
	        get: function get() {
	            var _this3 = this;
	
	            return Object.assign(Object.assign({}, _base2.default.DEFAULTS), {
	                outer_width: 600,
	                outer_height: 400,
	                margin: {
	                    top: 20,
	                    left: 30,
	                    bottom: 20,
	                    right: 30
	                },
	                y_ticks: 7,
	                chart_class: 'd3-stacked-bar-chart',
	                fnClassName: function fnClassName(name) {
	                    return name.replace(/\s+/g, '-').toLowerCase();
	                },
	                xTickFormat: function xTickFormat(d, i) {
	                    return d;
	                },
	                yTickFormat: function yTickFormat(d, i) {
	                    return d;
	                },
	                divider_color: '#fff',
	                rect_color: '#0d793e',
	                hover_tooltips: true,
	                labels: true,
	                makeTooltipHtml: function makeTooltipHtml(item) {
	                    var html = '<b>' + item.title + '</b> <br> ' + item.value.toFixed(2) + ' ';
	                    if (_this3.units) {
	                        html = html + ' ' + _this3.units;
	                    }
	                    return html;
	                }
	            });
	        }
	    }]);
	
	    return StackedBar;
	}(_base2.default);
	
	exports.default = StackedBar;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _base = __webpack_require__(2);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComparativePie = function (_Chart) {
	  _inherits(ComparativePie, _Chart);
	
	  function ComparativePie() {
	    _classCallCheck(this, ComparativePie);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ComparativePie).apply(this, arguments));
	  }
	
	  _createClass(ComparativePie, [{
	    key: 'defineAxes',
	    value: function defineAxes() {
	      var comparative_pie = this;
	    }
	  }, {
	    key: 'drawData',
	    value: function drawData(data) {
	      var comparative_pie = this,
	          value_sum = d3.sum(data.values),
	          max_r = comparative_pie.max_r || Math.min(comparative_pie.width, comparative_pie.height) / 2,
	          max_sum = Math.max(data.comparative_sum, value_sum),
	          min_sum = Math.min(data.comparative_sum, value_sum),
	          min_r = Math.sqrt(min_sum / max_sum) * max_r,
	
	      // pythagorean theorem to get displace x/y value.
	      displace = Math.sqrt(Math.pow(Math.abs(max_r - min_r), 2) / 2);
	      comparative_pie.values_gte_comparative = value_sum >= data.comparative_sum;
	
	      // always draw smaller arc first.
	      if (comparative_pie.values_gte_comparative) {
	        comparative_pie.drawPie(data, max_r, 0);
	        comparative_pie.drawComparativeArc(min_r, displace);
	      } else {
	        comparative_pie.drawComparativeArc(max_r, 0);
	        comparative_pie.drawPie(data, min_r, displace);
	      }
	      comparative_pie.data = data;
	      return comparative_pie;
	    }
	  }, {
	    key: 'drawPie',
	    value: function drawPie(data, r, displace) {
	      var comparative_pie = this;
	      var arc = d3.svg.arc().outerRadius(r).innerRadius(0);
	
	      var labelArc = d3.svg.arc().outerRadius(r + comparative_pie.label_r).innerRadius(r + comparative_pie.label_r);
	
	      var pie = d3.layout.pie().sort(null);
	
	      var cx = comparative_pie.width / 2 - displace,
	          cy = comparative_pie.height / 2 + displace;
	
	      var arcs = comparative_pie.svg.selectAll(".d3-value-arc").data(pie(data.values));
	      arcs.exit().remove();
	      [arcs.enter().append('g'), arcs].forEach(function (g) {
	        g.attr("class", function (d, i) {
	          var category_class = comparative_pie.fnCategoryClass(data.categories[i]);
	          return ["d3-value-arc", category_class].join(' ');
	        }).attr('transform', 'translate(' + cx + ', ' + cy + ')');
	      });
	
	      // Draw slices
	      comparative_pie.svg.selectAll(".d3-value-arc").each(function (d, i) {
	        var paths = d3.select(this).selectAll('path').data([d]);
	
	        paths.exit().remove();
	        [paths.enter().append('path'), paths].forEach(function (path) {
	          path.attr("d", arc).style("fill", function (d, j) {
	            return comparative_pie.fnColor(data.categories[i]);
	          });
	        });
	      });
	
	      // draw labels
	      comparative_pie.svg.selectAll(".d3-value-arc").each(function (d, i) {
	        var labels = d3.select(this).selectAll("text").data([d]);
	        labels.exit().remove();
	        [labels.enter().append('text'), labels].forEach(function (label) {
	          label.attr("dy", ".35em").text(function (d, j) {
	            return data.categories[i];
	          }).attr("transform", function (d, j) {
	            var node = this,
	                centroid = labelArc.centroid(d);
	            centroid[0] -= node.getBBox().width / 2;
	            return "translate(" + centroid + ")";
	          });
	        });
	      });
	    }
	  }, {
	    key: 'drawSlice',
	    value: function drawSlice(value_arc, d, i, arc) {
	      var comparative_pie = this;
	    }
	  }, {
	    key: 'drawLabel',
	    value: function drawLabel(value_arc, d, i, labelArc) {
	      var comparative_pie = this;
	    }
	  }, {
	    key: 'drawComparativeArc',
	    value: function drawComparativeArc(r, displace) {
	      var comparative_pie = this,
	          cx = comparative_pie.width / 2 - displace,
	          cy = comparative_pie.height / 2 + displace,
	          comparative_arc = comparative_pie.svg.selectAll('.d3-comparative-arc').data([0]);
	      comparative_arc.exit().remove();
	
	      [comparative_arc.enter().append('circle'), comparative_arc].forEach(function (circle) {
	        circle.attr('class', 'd3-comparative-arc').style('stroke', 'black').style('stroke-width', 2).style('fill', function () {
	          if (comparative_pie.values_gte_comparative) {
	            return 'none';
	          } else {
	            return comparative_pie.defecit_fill;
	          }
	        }).style('stroke-dasharray', '5,5').attr('r', r).attr('cx', cx).attr('cy', cy);
	      });
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw(opts) {
	      var chart = this;
	      Object.assign(chart, opts);
	      chart.height = chart.outer_height - chart.margin.top - chart.margin.bottom;
	      chart.width = chart.outer_width - chart.margin.left - chart.margin.right;
	
	      d3.select(chart.container + ' svg').attr("width", chart.outer_width).attr("height", chart.outer_height).select(".d3-object-container").attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");
	      chart.defineAxes();
	      if (chart.afterAxes) chart.afterAxes();
	      chart.drawData(chart.data);
	    }
	  }, {
	    key: 'chart_options',
	    get: function get() {
	      return Object.assign(Object.assign({}, _base2.default.DEFAULTS), {
	        outer_width: 600,
	        outer_height: 400,
	        margin: {
	          top: 20,
	          left: 30,
	          bottom: 20,
	          right: 30
	        },
	        chart_class: 'd3-comparative-pie-chart',
	        fnColor: d3.scale.category20(),
	        fnCategoryClass: function fnCategoryClass(category) {
	          return category.toLowerCase().replace(/\s+/g, '-');
	        },
	        defecit_fill: 'lightgrey',
	        label_r: -30,
	        max_r: undefined
	      });
	    }
	  }]);
	
	  return ComparativePie;
	}(_base2.default);
	
	exports.default = ComparativePie;

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.min.js
 **/